package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventRepository
import kotlinx.coroutines.flow.Flow

class ObserveTableEventsUseCase(
    private val gameEventRepository: GameEventRepository
) {
    operator fun invoke(tableId: String): Flow<GameEvent> {
        return gameEventRepository.observeNewEvents(tableId)
    }
}
